import { useState } from "react"
import FormField from "../FormField"
import { Input, InputProps } from "@/components/ui/input"
import { UseFormReturn, useWatch } from "react-hook-form"

interface FormFieldEditInlineProps {
  name: string
  inputProps?: InputProps
  after?: React.ReactNode
  form: UseFormReturn<any>
  onBlur?: (value: string) => void
}

function FormFieldEditInline(props: FormFieldEditInlineProps) {
  const [editing, setEditing] = useState(false)
  const value = useWatch({ name: props.name })

  if (editing) {
    return (
      <FormField name={props.name}>
        <Input
          size="sm"
          autoFocus
          className="h-6 border-none bg-transparent pl-1 !text-[16px] font-semibold shadow-none outline-none -ml-1.5 max-w-[400px]"
          onBlur={() => {
            setEditing(false)
            props.onBlur?.(value)
          }}
          {...props.inputProps}
        />
      </FormField>
    )
  }

  return (
    <>
      <button
        type="button"
        onClick={() => setEditing(true)}
        className="!font-normal text-md hover:bg-card-hover flex items-center gap-2 px-1 rounded-lg -ml-1 group"
      >
        {value}
        <IconHugeiconsEdit02 className="size-4 opacity-0 group-hover:opacity-100 transition-opacity duration-125 ease-in-out" />
      </button>
      {props.after}
    </>
  )
}

export default FormFieldEditInline
